/* eslint-disable no-unused-vars */
// import Connectors from '../../Charger/Conectors';
import CorporateChargingSessionsGrid from '../CorporateChargingSessionsGrid';
// import ChargingSessions from '../../Charger/ChargingSessions';
// import OCPPLogs from '../../Charger/OCPPLogs';
// import OCPPConnectionHistory from '../../Charger/OCPPConnectionsHistory';
// import ChargerControls from '../../Charger/ChargerControls';
import { useEffect } from 'react';
import {
  Button,
  Typography,
  // Row,
  // Col,
  // Divider,
  Select,
  Spin,
} from 'antd';
import { Row, Col, Card } from 'reactstrap';
import { Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import { find, get } from 'lodash-es';
import QRCode from 'qrcode.react';
import { DownloadOutlined, PlusCircleOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const { Option } = Select;

export default function ChargerDetailCard({
  cp,
  cpid,
  isChargerLoading,
  activePopoverId,
  onClickOutside,
}) {
  useEffect(() => {
    const handleClickOutside = (event) => {
      // if (ref.current && !ref.current.contains(event.target)) {
      //   onClickOutside && onClickOutside();
      // }
      onClickOutside && onClickOutside();
    };
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [onClickOutside]);
  const Divider = () => (
    <div style={{ border: '1px solid #F5F8FA', margin: 5 }}></div>
  );

  return (
    <>
      <Popover
        placement="right"
        isOpen={activePopoverId === `Popover${cpid}`}
        target={`Popover${cpid}`}
        className="popover-wrap"
        style={{ pointerEvents: 'none' }}
      >
        <PopoverHeader>Charger Details</PopoverHeader>
        <PopoverBody>
          <Spin tip="Loading..." spinning={isChargerLoading}>
            <Card style={{ border: '0px solid #e7e7e9' }}>
              <div>
                <Row>
                  <Col sm="3" md="3" lg="3">
                    <strong>Charger Id: </strong>
                  </Col>
                  <Col sm="9" md="9" lg="9">
                    {get(cp, 'ID')}
                  </Col>
                </Row>
                <Row>
                  <Col sm="3" md="3" lg="3">
                    <strong>Name: </strong>
                  </Col>
                  <Col sm="9" md="9" lg="9">
                    {get(cp, 'NAME')}
                  </Col>
                </Row>
                <Row>
                  <Col sm="3" md="3" lg="3">
                    <strong>Address: </strong>
                  </Col>
                  <Col sm="9" md="9" lg="9">
                    {get(cp, 'ADDRESS')}
                  </Col>
                </Row>
                <Row>
                  <Col sm="3" md="3" lg="3">
                    <strong>State: </strong>
                  </Col>
                  <Col sm="9" md="9" lg="9">
                    {get(cp, 'STATE')}
                  </Col>
                </Row>
                <Row>
                  <Col sm="3" md="3" lg="3">
                    <strong>Lat/Long: </strong>
                  </Col>
                  <Col sm="9" md="9" lg="9">
                    {get(cp, 'COORDS')}
                  </Col>
                </Row>
                <Row>
                  <Col sm="3" md="3" lg="3">
                    <strong>Capacity: </strong>
                  </Col>
                  <Col sm="9" md="9" lg="9">
                    {get(cp, 'ENERGY')} kW
                  </Col>
                </Row>
                <Row>
                  <Col sm="3" md="3" lg="3">
                    <strong>Type: </strong>
                  </Col>
                  <Col sm="9" md="9" lg="9">
                    {get(cp, 'IS_DC') === 1 ? 'DC' : 'AC'}
                  </Col>
                </Row>
                <Row>
                  <Col sm="3" md="3" lg="3">
                    <strong>Open Timing: </strong>
                  </Col>
                  <Col sm="9" md="9" lg="9">
                    {get(cp, `TIMING`) === '00:00-23:59'
                      ? 'Always Open'
                      : get(cp, 'TIMING')}
                  </Col>
                </Row>
              </div>
            </Card>
          </Spin>
        </PopoverBody>
      </Popover>
    </>
  );
}
